export default __webpack_public_path__ + "a28f8e41e9687a6340a993e714c7d78c.svg";